import { memo } from 'react';

import { Autocomplete, Grid, TextField } from '@mui/material';
import { v4 as uuidv4 } from "uuid"
const AutocompleteWrapper = ({ label, value, onChange, options, required, field, xs, sm, md, lg, disabled }) => {
  return (
    <Grid item xs={xs} sm={sm} md={md} lg={lg}>
      <Autocomplete
        freeSolo
        selectOnFocus
        disabled={disabled}
        autoComplete={true}
        autoHighlight={true}
        autoSelect={true}
        clearOnBlur
        fullWidth
        size='small'
        options={options}
        sx={{height: "42px"}}
        getOptionLabel={option => {
          if (typeof option === 'string') {
            return option;
          }
          return option.name ? `${option.name}` : '';
        }}
        renderOption={(props, option) => (
          <li {...props} key={uuidv4()}>
            {(typeof option === 'string'? option: (option.name ? `${option.name}` : ''))}
          </li>
        )}
        renderInput={params => <TextField {...params} label={label} required={required} disabled={disabled} error={required && (value == null || value == '')} />}
        value={options.find(option => option.id === value)?.name || ''}
        onChange={(_, newValue) => {
          if (newValue) {
            onChange(field, newValue.id);
          } else {
            onChange(field, '');
          }
        }}
      />
    </Grid>
  );
};

AutocompleteWrapper.defaultProps = {
  label: '',
  value: '',
  xs: 12,
  sm: 6,
  md: 4,
  lg: 2,
  required: null,
  disabled: null,
};

export default memo(AutocompleteWrapper);
